import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { obtenerListaCalendarios } from "../../../store/Calendario/thunkCalendario";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { setLimpiarTemporales } from "../../../store/Eventos/eventoSlice";

export const ListaCalendario = () => {
    const navigate = useNavigate();
    const [Calendarios, setCalendarios] = useState([]);
    const [loading, setLoading] = useState(true); // Estado para controlar la carga
    const [currentPage, setCurrentPage] = useState(1); // Estado para la página actual
    const [clientsPerPage, setClientsPerPage] = useState(10); // Calendarios por página
    const [nombreEvento, setNombreEvento] = useState(""); // Filtro por nombre del evento
    const [nombreHotel, setNombreHotel] = useState([]); // Filtro por hotel (múltiple)
    const [nombreEmpresa, setNombreEmpresa] = useState([]); // Filtro por empresa (múltiple)
    const [nombreCliente, setNombreCliente] = useState([]); // Filtro por cliente (múltiple)
    const [nombresAdmins, setNombresAdmins] = useState([]); // Filtro por admins (múltiple)
    const [fechaInicio, setFechaInicio] = useState(""); // Filtro por fecha de inicio
    const [fechaFinal, setFechaFinal] = useState(""); // Filtro por fecha final
    const [openFilters, setOpenFilters] = useState(false); // Estado para colapsar/expandir filtros
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchCalendario = async () => {
            setLoading(true); // Inicia la carga
            const response = await dispatch(obtenerListaCalendarios());
            setCalendarios(response || []);
            setLoading(false); // Finaliza la carga
        };

        fetchCalendario();
    }, [dispatch]);

    // Obtener las opciones únicas para los selects de los valores de los calendarios
    const uniqueOptions = (key) => {
        const options = Calendarios.map((calendario) => calendario[key])
            .filter((value, index, self) => value && self.indexOf(value) === index)
            .map((value) => ({ value, label: value }));
        return options;
    };

    // Obtener los nombres únicos de los admins (separados por comas)
    const uniqueAdminOptions = () => {
        const allAdmins = Calendarios.flatMap((calendario) => (calendario.nombres_admins ? calendario.nombres_admins.split(",") : []));
        const uniqueAdmins = Array.from(new Set(allAdmins.map((admin) => admin.trim()))); // Eliminar duplicados y limpiar espacios
        return uniqueAdmins.map((admin) => ({ value: admin, label: admin }));
    };

    // Función para verificar si un valor está en la lista seleccionada (filtros múltiples)
    const isValueInSelected = (value, selectedList) => {
        if (selectedList.length === 0) return true;
        return selectedList.some((selected) => selected.value === value);
    };

    // Filtrar los calendarios en función de los filtros
    const filteredCalendarios = Calendarios.filter((calendario) => {
        // Filtrar por fechas (fech_Inicio_evento y fech_final_evento) sin considerar la hora
        const fechaEventoInicio = new Date(calendario.fech_Inicio_evento).setHours(0, 0, 0, 0);
        const fechaEventoFinal = new Date(calendario.fech_final_evento).setHours(0, 0, 0, 0);
        const fechaInicioFiltro = fechaInicio ? new Date(fechaInicio).setHours(0, 0, 0, 0) : null;
        const fechaFinalFiltro = fechaFinal ? new Date(fechaFinal).setHours(0, 0, 0, 0) : null;

        const pasaFiltroFecha = (!fechaInicioFiltro || fechaEventoInicio >= fechaInicioFiltro) && (!fechaFinalFiltro || fechaEventoFinal <= fechaFinalFiltro);

        return (nombreEvento === "" || calendario.nombre_evento.toLowerCase().includes(nombreEvento.toLowerCase())) && isValueInSelected(calendario.nombre_hotel, nombreHotel) && isValueInSelected(calendario.nombre_empresa, nombreEmpresa) && isValueInSelected(calendario.nombre_cliente, nombreCliente) && (nombresAdmins.length === 0 || calendario.nombres_admins.split(",").some((admin) => nombresAdmins.some((selectedAdmin) => selectedAdmin.value === admin.trim()))) && pasaFiltroFecha;
    });

    // Ordenar los calendarios por la fecha de inicio del evento, de más reciente a más antigua
    const sortedCalendarios = filteredCalendarios.sort((a, b) => {
        const fechaA = new Date(a.fech_Inicio_evento);
        const fechaB = new Date(b.fech_Inicio_evento);
        return fechaB - fechaA; // Ordenar de más reciente a más antiguo
    });

    // Obtener el índice de los calendarios a mostrar según la página
    const indexOfLastClient = currentPage * clientsPerPage;
    const indexOfFirstClient = indexOfLastClient - clientsPerPage;
    const currentCalendarios = sortedCalendarios.slice(indexOfFirstClient, indexOfLastClient);

    // Cambiar la cantidad de calendarios por página
    const handleClientsPerPageChange = (e) => {
        setClientsPerPage(parseInt(e.target.value));
        setCurrentPage(1); // Reiniciar a la primera página cuando se cambia la cantidad por página
    };

    // Cambiar a la página anterior
    const handlePrevPage = () => {
        setCurrentPage(currentPage > 1 ? currentPage - 1 : 1);
    };

    // Cambiar a la página siguiente
    const handleNextPage = () => {
        setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages);
    };


    const irCrearevento = () => {
            dispatch(setLimpiarTemporales())
            navigate(`/evento/crear`); // Navega a la ruta deseada
    };


     const irEvento = (id) => {
         navigate(`/evento/ver?data=${id}`); // Navega a la ruta deseada
     };

    // Calcular el total de páginas
    const totalPages = Math.ceil(sortedCalendarios.length / clientsPerPage);

    return (
        <>
            {loading ? (
                // Mostrar el círculo de carga cuando los calendarios están cargando
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50vh",
                    }}
                >
                    <CircularProgress />
                </div>
            ) : (
                <>
                    {/* Botón para mostrar u ocultar los filtros */}
                    <Button onClick={() => setOpenFilters(!openFilters)} aria-expanded={openFilters} aria-label="show filters" variant="contained" style={{ marginBottom: "15px" }}>
                        {openFilters ? "Ocultar Filtros" : "Mostrar Filtros"}
                    </Button>

                    {/* Filtros */}
                    <Collapse in={openFilters}>
                        <div className="row">
                            {/* Filtro por nombre del evento */}
                            <div className="col-md-4 mb-2">
                                <label>Nombre del Evento</label>
                                <input type="text" className="form-control" value={nombreEvento} onChange={(e) => setNombreEvento(e.target.value)} placeholder="Buscar por nombre del evento" />
                            </div>

                            {/* Filtro por hotel */}
                            <div className="col-md-4 mb-2">
                                <label>Hotel</label>
                                <Select options={uniqueOptions("nombre_hotel")} value={nombreHotel} onChange={setNombreHotel} isMulti isClearable placeholder="Seleccionar hoteles" />
                            </div>

                            {/* Filtro por empresa */}
                            <div className="col-md-4 mb-2">
                                <label>Empresa</label>
                                <Select options={uniqueOptions("nombre_empresa")} value={nombreEmpresa} onChange={setNombreEmpresa} isMulti isClearable placeholder="Seleccionar empresas" />
                            </div>

                            {/* Filtro por cliente */}
                            <div className="col-md-4 mb-2">
                                <label>Cliente</label>
                                <Select options={uniqueOptions("nombre_cliente")} value={nombreCliente} onChange={setNombreCliente} isMulti isClearable placeholder="Seleccionar clientes" />
                            </div>

                            {/* Filtro por admins */}
                            <div className="col-md-4 mb-2">
                                <label>Admins</label>
                                <Select options={uniqueAdminOptions()} value={nombresAdmins} onChange={setNombresAdmins} isMulti isClearable placeholder="Seleccionar admins" />
                            </div>

                            {/* Filtro por fecha de inicio */}
                            <div className="col-md-4 mb-2">
                                <label>Fecha de Inicio del Evento</label>
                                <input type="date" className="form-control" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                            </div>

                            {/* Filtro por fecha final del evento */}
                            <div className="col-md-4 mb-2">
                                <label>Fecha Final del Evento</label>
                                <input type="date" className="form-control" value={fechaFinal} onChange={(e) => setFechaFinal(e.target.value)} />
                            </div>
                        </div>
                    </Collapse>

                    {/* Selector de cantidad de calendarios por página */}
                    <div className="d-flex justify-content-between mb-3">
                        <div className="d-flex justify-content-between mb-3">
                            <select id="clientsPerPage" className="form-select" value={clientsPerPage} onChange={handleClientsPerPageChange} style={{ width: "100px" }}>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                                <option value={70}>70</option>
                                <option value={100}>100</option>
                            </select>
                        </div>
                    </div>
                    <button className="btn btn-dark me-2" onClick={() => irCrearevento()}>
                        Crear Nuevo evento en blanco
                    </button>
                    <br />
                    <br />

                    {/* Mostrar la tabla cuando los calendarios están cargados */}
                    <div className="table-responsive">
                        <table
                            className="table table-striped table dt-responsive w-100 display text-left hoverable-table"
                            style={{
                                fontSize: "15px",
                                width: "100%",
                                textAlign: "left",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th>Nombre Evento</th>
                                    <th>Fecha inicio</th>
                                    <th>Hotel</th>
                                    <th>Ejecutivos</th>
                                    <th>Empresa</th>
                                    <th>Cliente</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentCalendarios.length > 0 ? (
                                        currentCalendarios.map((calendario, index) => (
                                        <tr key={index} onClick={() => irEvento(calendario.id_evento)}>
                                            <td>{calendario.nombre_evento || "SIN NOMBRE"}</td>
                                            <td>{calendario.fech_Inicio_evento || "SIN FECHA"}</td>
                                            <td>{calendario.nombre_hotel || "SIN HOTEL"}</td>
                                            <td>{calendario.nombres_admins || "SIN ADMINS"}</td>
                                            <td>{calendario.nombre_empresa === "0" ? "--" : calendario.nombre_empresa || "SIN EMPRESA"}</td>
                                            <td>{calendario.nombre_cliente === "0" ? "--" : calendario.nombre_cliente || "SIN CLIENTE"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            No se encontraron calendarios.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Paginación */}
                    <div className="pagination-controls" style={{ textAlign: "center", marginTop: "20px" }}>
                        <button onClick={handlePrevPage} disabled={currentPage === 1} className="btn btn-light">
                            Anterior
                        </button>
                        <span style={{ margin: "0 10px" }}>
                            Página {currentPage} de {totalPages}
                        </span>
                        <button onClick={handleNextPage} disabled={currentPage === totalPages} className="btn btn-light">
                            Siguiente
                        </button>
                    </div>
                </>
            )}
        </>
    );
};
